import { state } from './state'
import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'

export const authentication = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
